// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1M-am","col":"styles_col__1_B-C"};